module.exports = __webpack_public_path__ + "static/GratinGreen-9f207905ca36c79fb9b7353a90e42e81.png";